const news_view_all = document.querySelectorAll('.listing-news__view-all');
for( let i=0; i<news_view_all.length; i++ ){
	news_view_all[i].addEventListener('click', news_view_all_onClick, {
		capture: true,
		passive: true
	} );
}

function news_view_all_onClick(e){

	try {

		e.preventDefault();

		let this_button = e.currentTarget;
		let this_list_hidden_items = this_button.previousElementSibling.querySelectorAll('.is-hidden');

		for( let i=0; i<this_list_hidden_items.length; i++ ){
			this_list_hidden_items[i].classList.remove('is-hidden')
		}

		this_button.classList.add('is-hidden');

	} catch (error) {
		console.log( 'Error with the listing View All button: ', error );
	}

}
